module.exports = __webpack_public_path__ + "img/25.3081e611.jpeg";